export default function secureJsonParse(maybeJson: string): any {
  try {
    return JSON.parse(maybeJson);
  } catch (error) {
    return null;
  }
}
